import * as tslib_1 from "tslib";
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Observable, of, zip } from 'rxjs';
import { switchMap, catchError, mergeMap } from 'rxjs/operators';
import { SnackbarService } from 'app/services/snackbar.service';
import { OwnRestrictedListService } from 'modules/core/services/own-restricted-list.service';
import { OwnRestrictedListActionTypes, GetOwnRestrictedListSuccess, GetOwnRestrictedListFailure, GetOwnRestrictedListsSuccess, GetOwnRestrictedListsFailure, CreateOwnRestrictedListSuccess, CreateOwnRestrictedListFailure, UpdateOwnRestrictedListSuccess, UpdateOwnRestrictedListFailure, GetRestrictedNames, GetRestrictedNamesSuccess, GetRestrictedNamesFailure, CreateRestrictedNameSuccess, CreateRestrictedNameFailure, EditRestrictedNameSuccess, EditRestrictedNameFailure } from '../actions/own-restricted-list.actions';
var OwnRestrictedListEffects = /** @class */ (function () {
    function OwnRestrictedListEffects(actions$, snackBar, ownRestrictedListService) {
        var _this = this;
        this.actions$ = actions$;
        this.snackBar = snackBar;
        this.ownRestrictedListService = ownRestrictedListService;
        this.getOwnRestrictedList$ = this.actions$.pipe(ofType(OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LIST), mergeMap(function (res) {
            return _this.ownRestrictedListService.getOwnRestrictedList(res.payload);
        }), switchMap(function (res) {
            return of(new GetOwnRestrictedListSuccess(res));
        }), catchError(function (error) {
            return of(new GetOwnRestrictedListFailure(error.message));
        }));
        this.getOwnRestrictedLists$ = this.actions$.pipe(ofType(OwnRestrictedListActionTypes.GET_OWN_RESTRICTED_LISTS), mergeMap(function (res) {
            return _this.ownRestrictedListService.getOwnRestrictedLists(res.payload);
        }), switchMap(function (res) {
            return of(new GetOwnRestrictedListsSuccess(res));
        }), catchError(function (error) {
            return of(new GetOwnRestrictedListsFailure(error.message));
        }));
        this.createOwnRestrictedList = this.actions$.pipe(ofType(OwnRestrictedListActionTypes.CREATE_OWN_RESTRICTED_LIST), mergeMap(function (res) {
            return _this.ownRestrictedListService.createOwnRestrictedList(res.payload);
        }), switchMap(function (res) {
            return of(new CreateOwnRestrictedListSuccess(res));
        }), catchError(function (error) {
            return of(new CreateOwnRestrictedListFailure(error.message));
        }));
        this.updateOwnRestrictedList$ = this.actions$.pipe(ofType(OwnRestrictedListActionTypes.UPDATE_OWN_RESTRICTED_LIST), mergeMap(function (res) {
            return _this.ownRestrictedListService.updateOwnRestrictedList(res.payload);
        }), switchMap(function (res) {
            return of(new UpdateOwnRestrictedListSuccess(res));
        }), catchError(function (error) {
            return of(new UpdateOwnRestrictedListFailure(error.message));
        }));
        this.getRestrictedNames$ = this.actions$.pipe(ofType(OwnRestrictedListActionTypes.GET_RESTRICTED_NAMES), mergeMap(function (res) {
            return _this.ownRestrictedListService.getRestrictedNames(res.payload);
        }), switchMap(function (res) {
            return of(new GetRestrictedNamesSuccess(res));
        }), catchError(function (error) {
            return of(new GetRestrictedNamesFailure(error.message));
        }));
        this.createRestrictedName$ = this.actions$.pipe(ofType(OwnRestrictedListActionTypes.CREATE_RESTRICTED_NAME), mergeMap(function (res) {
            return _this.ownRestrictedListService.createRestrictedName(res.payload);
        }), switchMap(function (res) {
            _this.snackBar.success('Name successfully added to list');
            var getNamesRequest = {
                listId: res.ownSublist,
                data: {
                    search: '',
                    sort: '-active, -updated_at',
                    offset: 0,
                    limit: 5,
                }
            };
            return [new CreateRestrictedNameSuccess(res), new GetRestrictedNames(getNamesRequest)];
        }), catchError(function (error) {
            return of(new CreateRestrictedNameFailure(error.message));
        }));
        this.editRestrictedName$ = this.actions$.pipe(ofType(OwnRestrictedListActionTypes.EDIT_RESTRICTED_NAME), mergeMap(function (res) {
            var editNamesRequest = {
                nameId: res.payload.nameId,
                data: res.payload.data
            };
            return zip(of(res.payload), _this.ownRestrictedListService.editRestrictedName(editNamesRequest));
        }), switchMap(function (_a) {
            var payload = _a[0], res = _a[1];
            _this.snackBar.success('Name successfully updated');
            var getNamesRequest = {
                listId: res.ownSublist
            };
            if (payload.tableSettings) {
                getNamesRequest.data = payload.tableSettings;
            }
            else {
                getNamesRequest.data = {
                    search: '',
                    sort: '-active, -updated_at',
                    offset: 0,
                    limit: 5,
                };
            }
            return [new EditRestrictedNameSuccess(res), new GetRestrictedNames(getNamesRequest)];
        }), catchError(function (error) {
            return of(new EditRestrictedNameFailure(error.message));
        }));
    }
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OwnRestrictedListEffects.prototype, "getOwnRestrictedList$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OwnRestrictedListEffects.prototype, "getOwnRestrictedLists$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OwnRestrictedListEffects.prototype, "createOwnRestrictedList", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OwnRestrictedListEffects.prototype, "updateOwnRestrictedList$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OwnRestrictedListEffects.prototype, "getRestrictedNames$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OwnRestrictedListEffects.prototype, "createRestrictedName$", void 0);
    tslib_1.__decorate([
        Effect(),
        tslib_1.__metadata("design:type", Observable)
    ], OwnRestrictedListEffects.prototype, "editRestrictedName$", void 0);
    return OwnRestrictedListEffects;
}());
export { OwnRestrictedListEffects };
